import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { Actions } from '../../actions';
import { CREATE_SUBSCRIPTION_SUCCESS } from '../../subscription/actions';
import { CreateSubscriptionSuccess } from '../../subscription/action-creators';
import { getOrderKey } from '../utils';
import { EmptyBasket } from '../action-creators';


export const deleteOrderCacheEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, CreateSubscriptionSuccess>(
      CREATE_SUBSCRIPTION_SUCCESS
    ),
    map((action) => {
      const key = getOrderKey(action.newSubscription.clientId as string);

      localStorage.removeItem(key);

      return new EmptyBasket();
    })
  );